import resourcesController from './resourcesController'

export default resourcesController



// WEBPACK FOOTER //
// ../src/controllers/resourcesController/index.js